export class Registry {
    static _components = new Map(); // key -> { Class, prio, source }
    static _services = new Map();   // key -> instance
    static _hooks = new Map();      // name -> Set<fn>

    static on(hook, fn){ (this._hooks.get(hook) ?? this._hooks.set(hook,new Set()).get(hook)).add(fn); }
    static emit(hook, payload){ this._hooks.get(hook)?.forEach(fn => fn(payload)); }

    static registerComponent(key, Class, { prio = 0, source = "unknown" } = {}){
        const cur = this._components.get(key);
        if (!cur || prio >= cur.prio) {
            this._components.set(key, { Class, prio, source });
            this.emit("afterRegisterComponent", { key, prio, source });
        } else {
            console.warn(`[Registry] Skip "${key}" von ${source} (prio ${prio}) < existierend (prio ${cur.prio})`);
        }
    }
    static getComponent(key){ return this._components.get(key)?.Class; }

    static registerService(key, instance){
        if (this._services.has(key)) console.warn(`[Registry] Service "${key}" überschrieben.`);
        this._services.set(key, instance);
    }
    static getService(key){ return this._services.get(key); }
}